import { css, CSSObject, DefaultTheme, FlattenSimpleInterpolation } from 'styled-components';
import theme from '@cld/theme-helper';
import { defaultProps } from './props';

const t = theme({ basePath: 'components.typography' });

export type TypographySize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export type TypographyType = 'contrastInvert' | 'regular' | 'highContrast' | 'lowContrast' | 'url' | 'success' | 'warning' | 'error' | 'disabled';

export interface TypographyProps {
  /** Size of the text */
  size?: TypographySize;
  /** Styling of the text */
  type?: TypographyType;
  /** current styled components theme */
  theme: DefaultTheme;
}

type ObjectWithStyles = Pick<CSSObject, 'fontSize' | 'lineHeight'> & { fontWeight: number | string; color: string };

function typographyMixin(props: TypographyProps): FlattenSimpleInterpolation;
function typographyMixin(props: TypographyProps, options: { asObject: false }): FlattenSimpleInterpolation;
function typographyMixin(props: TypographyProps, options: { asObject: true }): ObjectWithStyles;
function typographyMixin(props: TypographyProps, options?: { asObject: boolean }) {
  const nextProps = { ...defaultProps, ...props };

  const attrs: ObjectWithStyles = {
    fontSize: t`${'size'}.size`(nextProps),
    lineHeight: t`${'size'}.lineHeight`(nextProps),
    fontWeight: t`${'size'}.type.${'type'}.weight`(nextProps),
    color: t`${'size'}.type.${'type'}.color`(nextProps) as string,
  };

  if (options?.asObject) {
    return attrs;
  }

  return css`
    font-size: ${attrs.fontSize};
    line-height: ${attrs.lineHeight};
    font-weight: ${attrs.fontWeight};
    color: ${attrs.color};
  `;
}

export { typographyMixin };
